module.exports = __webpack_public_path__ + "img/selected7-min.fb8d02f0.png";